// import BackTopBoxIcon from '../../../assets/images/c-back-top-icon-new.png';
import { doc } from "prettier";
import "./style.scss";
import classNames from 'classnames';
interface IProps {
  readonly scrollPosition?: 'bottom' | 'top' | '';
  readonly scrolling?: boolean;
  readonly onclick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

let animateTimer:any = null
export const BackTopBox = (props: IProps) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    props.onclick?.(event);
    document.querySelector(".backTopEle")?.classList.add("animate");
    if(animateTimer){
      clearTimeout(animateTimer);
    }
    animateTimer = setTimeout(() => {
      document.querySelector(".backTopEle")?.classList.remove("animate");
    }, 1000);
   
  };
  return (
    <div
      className={classNames(
        `backTopBox`,
        props.scrolling ? `isScrolling` : `isStopScrolling`,
        props.scrollPosition === 'bottom'
          ? `isDistanceBotton`
          : `isNotDistanceBotton`,
        props.scrollPosition === 'top' && `hasBackTop`
      )}
      onClick={handleClick}
    >
      <span className={`backTopEle`}></span>
      {/* <img src={BackTopBoxIcon} width={64} height={112} /> */}
    </div>
  );
};
